import { FC } from 'react';

import { Formik } from 'formik';
import useModal from 'ui/partials/Modal/useModal';
import { type FormikHelpers } from 'formik';

import {
  TASK_ASSOCIATE_DEAL_SCHEMA,
  TASK_ASSOCIATE_DEAL_FORM,
} from '../forms/schema';
import TaskAssociateDealForm from '../forms/TaskAssociateDealForm';

type TaskAssociateDealModalProps = {
  handleSubmit: (dealId: string) => void;
};

const TaskAssociateDealModal: FC<TaskAssociateDealModalProps> = ({
  handleSubmit,
}) => {
  const { hideModal } = useModal();

  const onSubmit = (
    values: TASK_ASSOCIATE_DEAL_FORM,
    { setSubmitting, resetForm }: FormikHelpers<TASK_ASSOCIATE_DEAL_FORM>,
  ) => {
    handleSubmit(values.dealId as string);
    setSubmitting(false);
    resetForm();
    hideModal();
  };
  return (
    <Formik<TASK_ASSOCIATE_DEAL_FORM>
      initialValues={{}}
      onSubmit={onSubmit}
      validationSchema={TASK_ASSOCIATE_DEAL_SCHEMA}
      enableReinitialize
    >
      {({ isSubmitting }) => {
        return <TaskAssociateDealForm isLoading={isSubmitting} />;
      }}
    </Formik>
  );
};

export default TaskAssociateDealModal;
